"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.RealmVoterClient = exports.REALM_VOTER_ID = void 0;
const anchor_1 = require("@coral-xyz/anchor");
const web3_js_1 = require("@solana/web3.js");
const realm_voter_1 = require("./realm_voter");
exports.REALM_VOTER_ID = new web3_js_1.PublicKey('GRmVtfLq2BPeWs5EDoQoZc787VYkhdkA11k63QM1Xemz');
class RealmVoterClient {
    constructor(program, devnet) {
        this.program = program;
        this.devnet = devnet;
    }
    static connect(provider, devnet) {
        return __awaiter(this, void 0, void 0, function* () {
            // alternatively we could fetch from chain
            // const idl = await Program.fetchIdl(VSR_ID, provider);
            const idl = realm_voter_1.IDL;
            return new RealmVoterClient(new anchor_1.Program(idl, exports.REALM_VOTER_ID, provider), devnet);
        });
    }
}
exports.RealmVoterClient = RealmVoterClient;
//# sourceMappingURL=client.js.map